import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const COOKIE_KEY = "psl_cookies_accepted";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(COOKIE_KEY)) {
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, "1");
    setShow(false);
  };

  if (!show) return null;
  return (
    <div
      className="fixed bottom-3 left-3 right-3 md:left-auto md:right-6 md:bottom-6 md:max-w-sm z-[1000] bg-[#1F4032] text-white p-4 md:p-5 rounded-md shadow-2xl"
      data-testid="cookie-banner"
    >
      <div className="text-xs md:text-sm leading-relaxed mb-3 md:mb-4">
        MML utilise uniquement des cookies <strong>strictement nécessaires</strong> au
        fonctionnement du service (session, auth). Aucun tracking publicitaire.
      </div>
      <div className="flex items-center justify-between gap-3">
        <Link
          to="/privacy"
          className="text-xs underline underline-offset-4 text-white/70 hover:text-white"
        >
          En savoir plus
        </Link>
        <button
          onClick={accept}
          data-testid="cookie-accept"
          className="bg-white text-[#1F4032] text-sm font-medium px-4 py-2 rounded-md hover:bg-white/90"
        >
          J'ai compris
        </button>
      </div>
    </div>
  );
}
